// import Vue from 'vue'

export default {
  // SET_USER: (state, { id, user }) => {
  //   Vue.set(state.users, id, user || false) /* false means user not found */
  // },

  // persisted state (use local storage to save data)
  setAuthData: (state, data = null) => {
    state.auth_data = data;
  },
  setAuthToken: (state, data = null) => {
    state.auth_token = data;
  },
  // filter size global
  setRecordSize: (state, data) => {
    state.record_size = data;
  },
  // filter date global
  setFromDate: (state, data) => {
    state.from_date = data;
  },
  setEndDate: (state, data) => {
    state.end_date = data;
  },

  // filter date per menu
  setFromDatePerMenu: (state, [menu, data]) => {

    if(menu === 'result-recent-location' || menu === 'target-detail-recent-location' || menu === 'all') {
        state.from_date_recent_location = data;
    }

    if(menu === 'result-application-usage' || menu === 'target-detail-application-usage' || menu === 'all') {
        state.from_date_application_usage = data;
    }

    if(menu === 'result-history-location' || menu === 'target-detail-history-location' || menu === 'all') {
        state.from_date_history_location = data;
    }

    if(menu === 'result-history-browsing' || menu === 'target-detail-history-browsing' || menu === 'all') {
        state.from_date_history_browsing = data;
    }

    if(menu === 'result-device-history' || menu === 'target-detail-device-history' || menu === 'all') {
        state.from_date_device_history = data;
    }

    if(menu === 'result-tethered-devices' || menu === 'target-detail-tethered-devices' || menu === 'all') {
        state.from_date_tethered_devices = data;
    }

    if(menu === 'result-possible-location' || menu === 'target-detail-possible-location' || menu === 'all') {
        state.from_date_possible_location = data;
    }

    if(menu === 'result-aerial-log' || menu === 'target-detail-aerial-log' || menu === 'all') {
        state.from_date_aerial_log = data;
    }

    if(menu === 'result-signal-status' || menu === 'target-detail-signal-status' || menu === 'all') {
        state.from_date_signal_status = data;
    }
  },
  setEndDatePerMenu: (state, [menu, data]) => {

    if(menu === 'result-recent-location' || menu === 'target-detail-recent-location' || menu === 'all') {
        state.end_date_recent_location = data;
    }

    if(menu === 'result-application-usage' || menu === 'target-detail-application-usage' || menu === 'all') {
        state.end_date_application_usage = data;
    }

    if(menu === 'result-history-location' || menu === 'target-detail-history-location' || menu === 'all') {
        state.end_date_history_location = data;
    }

    if(menu === 'result-history-browsing' || menu === 'target-detail-history-browsing' || menu === 'all') {
        state.end_date_history_browsing = data;
    }

    if(menu === 'result-device-history' || menu === 'target-detail-device-history' || menu === 'all') {
        state.end_date_device_history = data;
    }

    if(menu === 'result-tethered-devices' || menu === 'target-detail-tethered-devices' || menu === 'all') {
        state.end_date_tethered_devices = data;
    }

    if(menu === 'result-possible-location' || menu === 'target-detail-possible-location' || menu === 'all') {
        state.end_date_possible_location = data;
    }

    if(menu === 'result-aerial-log' || menu === 'target-detail-aerial-log' || menu === 'all') {
        state.end_date_aerial_log = data;
    }

    if(menu === 'result-signal-status' || menu === 'target-detail-signal-status' || menu == 'all') {
        state.end_date_signal_status = data;
    }
  },

  setFcmToken: (state, data) => {
    state.fcm_token = data;
  },

  setTargetRedirect: (state, data) => {
    state.target_redirect = data;
  },

  setMultiTrackingRedirect: (state, data) => {
    state.multi_tracking_redirect = data;
  },

  // --------------------------------------------------

  // load data clients
  setLoadDataStatusClientsList: (state, status) => {
    state.load_data_status_clients_list = status;
  },
  setLoadDataStatusClientsDetail: (state, status) => {
    state.load_data_status_clients_detail = status;
  },
  setLoadDataStatusClientsLogActivity: (state, status) => {
    state.load_data_status_clients_log_activity = status;
  },

  // load data modules
  setLoadDataStatusModulesList: (state, status) => {
    state.load_data_status_modules_list = status;
  },
  setLoadDataStatusModulesDetail: (state, status) => {
    state.load_data_status_modules_detail = status;
  },

  // load data function modules
  setLoadDataStatusFunctionList: (state, status) => {
    state.load_data_status_function_list = status;
  },
  setLoadDataStatusFunctionDetail: (state, status) => {
    state.load_data_status_function_detail = status;
  },

  // load data roles
  setLoadDataStatusRolesList: (state, status) => {
    state.load_data_status_roles_list = status;
  },
  setLoadDataStatusRolesDetail: (state, status) => {
    state.load_data_status_roles_detail = status;
  },

  // load data users
  setLoadDataStatusUsersList: (state, status) => {
    state.load_data_status_users_list = status;
  },
  setLoadDataStatusUsersDetail: (state, status) => {
    state.load_data_status_users_detail = status;
  },
  setLoadDataStatusUsersLogActivity: (state, status) => {
    state.load_data_status_users_log_activity = status;
  },
  setLoadDataStatusUsersLogActivityChart: (state, status) => {
    state.load_data_status_users_log_activity_chart = status;
  },

  setLoadDataStatusUsersLog: (state, status) => {
    state.load_data_status_users_log = status;
  },

  setLoadDataStatusUsersProfile: (state, status) => {
    state.load_data_status_users_profile = status;
  },

  // load data users tactical
  setLoadDataStatusUsersTacticalList: (state, status) => {
    state.load_data_status_users_tactical_list = status;
  },

  // load data acl
  setLoadDataStatusAclList: (state, status) => {
    state.load_data_status_acl_list = status;
  },

  // load data tactical devices
  setLoadDataStatusTacticalDevicesList: (state, status) => {
    state.load_data_status_tactical_devices_list = status;
  },
  setLoadDataStatusTacticalDevicesDetail: (state, status) => {
    state.load_data_status_tactical_devices_detail = status;
  },
  setLoadDataStatusTacticalDevicesListMap: (state, status) => {
    state.load_data_status_tactical_devices_list_map = status;
  },
  setLoadDataStatusTacticalDevicesMapLocation: (state, status) => {
    state.load_data_status_tactical_devices_map_location = status;
  },

  // load data territory virtual
  setLoadDataStatusTerritoryVirtualList: (state, status) => {
    state.load_data_status_territory_virtual_list = status;
  },
  // for edit / update
  setLoadDataStatusTerritoryVirtualDetail: (state, status) => {
    state.load_data_status_territory_virtual_detail = status;
  },
  // for detail page & notif
  setLoadDataStatusTerritoryVirtualDetailMapData: (state, status) => {
    state.load_data_status_territory_virtual_detail_map_data = status;
  },
  setLoadDataStatusTerritoryVirtualDetailMapHistory: (state, status) => {
    state.load_data_status_territory_virtual_detail_map_history = status;
  },
  setLoadDataStatusTerritoryVirtualDetailHistoryList: (state, status) => {
    state.load_data_status_territory_virtual_detail_history_list = status;
  },

  // load data case management
  setLoadDataStatusCaseManagementList: (state, status) => {
    state.load_data_status_case_management_list = status;
  },
  setLoadDataStatusCaseManagementDetail: (state, status) => {
    state.load_data_status_case_management_detail = status;
  },

  // load data single target
  setLoadDataStatusSingleTargetList: (state, status) => {
    state.load_data_status_single_target_list = status;
  },
  setLoadDataStatusSingleTargetDetail: (state, status) => {
    state.load_data_status_single_target_detail = status;
  },

  setLoadDataStatusSingleMonitoringList: (state, status) => {
    state.load_data_status_single_monitoring_list = status;
  },

  setLoadDataStatusSingleTargetTrackingList: (state, status) => {
    state.load_data_status_single_target_tracking_list = status;
  },

  // load data multi tracking / target
  setLoadDataStatusMultiTrackingList: (state, status) => {
    state.load_data_status_multi_tracking_list = status;
  },
  setLoadDataStatusMultiTrackingDetail: (state, status) => {
    state.load_data_status_multi_tracking_detail = status;
  },

  setLoadDataStatusMultiMonitoringList: (state, status) => {
    state.load_data_status_multi_monitoring_list = status;
  },

  setLoadDataStatusRecentLocationESList: (state, status) => {
    state.load_data_status_recent_location_es_list = status;
  },

  // load data meeting point 
  setLoadDataStatusMeetingPointList: (state, status) => {
    state.load_data_status_meeting_point_list = status;
  },
  // for edit / update
  setLoadDataStatusMeetingPointDetail: (state, status) => {
    state.load_data_status_meeting_point_detail = status;
  },

  // load data status on result sidebar menu
  setLoadDataStatusProfileSubheader: (state, status) => {
    state.load_data_status_profile_subheader = status;
  },
  setLoadDataStatusProfileSubheaderName: (state, status) => {
    state.load_data_status_profile_subheader_name = status;
  },
  // case profile with count
  setLoadDataStatusProfile: (state, status) => {
    state.load_data_status_profile = status;
  },
  setLoadDataStatusProfileIdentity: (state, status) => {
    state.load_data_status_profile_count.identity = status;
  },
  setLoadDataStatusProfileFamily: (state, status) => {
    state.load_data_status_profile_count.family = status;
  },

  setLoadDataStatusOverallAppUsage: (state, status) => {
    state.load_data_status_overall_app_usage = status;
  },
  setLoadDataStatusOverallDataLocation: (state, status) => {
    state.load_data_status_overall_data_location = status;
  },
  setLoadDataStatusOverallLogRecentLocation: (state, status) => {
    state.load_data_status_overall_log_recent_location = status;
  },
  // with count, location
  setLoadDataStatusLocation: (state, status) => {
    state.load_data_status_location = status;
  },
  setLoadDataStatusLocationRecent: (state, status) => {
    state.load_data_status_location_count.recent = status;
  },
  setLoadDataStatusLocationDetail: (state, status) => {
    state.load_data_status_location_count.detail = status;
  },
  setLoadDataStatusLocationHistory: (state, status) => {
    state.load_data_status_location_count.history = status;
  },
  // with count, browsing
  setLoadDataStatusBrowsing: (state, status) => {
    state.load_data_status_browsing = status;
  },
  setLoadDataStatusBrowsingHistory: (state, status) => {
    state.load_data_status_browsing_count.history = status;
  },
  setLoadDataStatusBrowsingLog: (state, status) => {
    state.load_data_status_browsing_count.log = status;
  },
  setLoadDataStatusBrowsingIpAddress: (state, status) => {
    state.load_data_status_browsing_count.ip_address = status;
  },
  setLoadDataStatusBrowsingUsage: (state, status) => {
    state.load_data_status_browsing_count.usage = status;
  },
  setLoadDataStatusBrowsingDuration: (state, status) => {
    state.load_data_status_browsing_count.duration = status;
  },
  setLoadDataStatusBrowsingAccessDomain: (state, status) => {
    state.load_data_status_browsing_count.access_domain = status;
  },
  // device history
  setLoadDataStatusDeviceHistory: (state, status) => {
    state.load_data_status_device_history = status;
  },
  // tethered device
  setLoadDataStatusTetheredDevice: (state, status) => {
    state.load_data_status_tethered_device = status;
  },
  // possible location
  setLoadDataStatusPossibleLocation: (state, status) => {
    state.load_data_status_possible_location = status;
  },
  // aerial log
  setLoadDataStatusAerialLog: (state, status) => {
    state.load_data_status_aerial_log = status;
  },
  // signal status
  setLoadDataStatusSignalStatus: (state, status) => {
    state.load_data_status_signal_status = status;
  },
  // vehicles
  setLoadDataStatusVehicles: (state, status) => {
    state.load_data_status_vehicles = status;
  }, 
  // etle
  setLoadDataStatusEtle: (state, status) => {
    state.load_data_status_etle = status;
  },
  // get contact
  setLoadDataStatusGetContact: (state, status) => {
    state.load_data_status_get_contact = status;
  },
  // travel history
  setLoadDataStatusTravelHistory: (state, status) => {
    state.load_data_status_travel_history = status;
  },
  // travel pl
  setLoadDataStatusTravel: (state, status) => {
    state.load_data_status_travel = status;
  },
  // travel pl
  setLoadDataStatusPln: (state, status) => {
    state.load_data_status_pln = status;
  },
  // Tokped
  setLoadDataStatusTokped: (state, status) => {
    state.load_data_status_tokped = status;
  },
  // CC
  setLoadDataStatusBankAccount: (state, status) => {
    state.load_data_status_bank_account = status;
  },
  // personal identity
  setLoadDataStatusPersonalIdentity: (state, status) => {
    state.load_data_status_personal_identity = status;
  },
  
  // face recognition
  setLoadDataStatusFaceRecognition: (state, status) => {
    state.load_data_status_face_recognition = status;
  },

  // search by name
  setLoadDataStatusSearchByName: (state, status) => {
    state.load_data_status_search_by_name = status;
  },
  setLoadDataStatusSearchByNameFilter: (state, [type, status]) => {
    state['load_data_status_search_by_name_filter_' + type] = status;
  },
  // setLoadDataStatusSearchByNameFilterProvince: (state, status) => {
  //   state.load_data_status_search_by_name_filter_province = status;
  // },
  // setLoadDataStatusSearchByNameFilterCity: (state, status) => {
  //   state.load_data_status_search_by_name_filter_city = status;
  // },
  // setLoadDataStatusSearchByNameFilterDistrict: (state, status) => {
  //   state.load_data_status_search_by_name_filter_district = status;
  // },

  // search by name travel history
  setLoadDataStatusSearchByNameTravelHistory: (state, status) => {
    console.log('setLoadDataStatusSearchByNameTravelHistory - status')
    console.log({status})
    state.load_data_status_search_by_name_travel_history = status;
  },

  // search by name paspor
  setLoadDataStatusSearchByNamePaspor: (state, status) => {
    state.load_data_status_search_by_name_paspor = status;
  },

  // search by name marketplace
  setLoadDataStatusSearchByNameMarketplace: (state, status) => {
    state.load_data_status_search_by_name_marketplace = status;
  },

  // search by name university
  setLoadDataStatusSearchByNameUniversity: (state, status) => {
    state.load_data_status_search_by_name_university = status;
  },

  // search by name or username personal identity
  setLoadDataStatusSearchByNamePersonalIdentity: (state, status) => {
    state.load_data_status_search_by_name_personal_identity = status;
  },

  // search by name or username personal identity
  setLoadDataStatusSearchByNamePln: (state, status) => {
    state.load_data_status_search_by_name_pln = status;
  },

  // notification
  setLoadDataStatusNotificationList: (state, status) => {
    state.load_data_status_notification_list = status;
  },
  // setLoadDataStatusNotificationCount: (state, status) => {
  //   state.load_data_status_notification_count = status;
  // },
  
  // tracking_history
  setLoadDataStatusTrackingHistoryList: (state, status) => {
    state.load_data_status_tracking_history_list = status;
  },

  // note_case
  setLoadDataStatusNoteCaseList: (state, status) => {
    state.load_data_status_note_case_list = status;
  },

  // note_target
  setLoadDataStatusNoteTargetList: (state, status) => {
    state.load_data_status_note_target_list = status;
  },
  // --------------------------------------------------

  // clients
  setClientsList: (state, data) => {
    state.clients_list = data;
  },
  setClientsDetail: (state, data) => {
    state.clients_detail = data;
  },
  setClientsLogActivity: (state, data) => {
    state.clients_log_activity = data;
  },

  // modules
  setModulesList: (state, data) => {
    state.modules_list = data;
  },
  setModulesDetail: (state, data) => {
    state.modules_detail = data;
  },

  // function modules
  setFunctionList: (state, data) => {
    state.function_list = data;
  },
  setFunctionDetail: (state, data) => {
    state.function_detail = data;
  },

  // roles
  setRolesList: (state, data) => {
    state.roles_list = data;
  },
  setRolesDetail: (state, data) => {
    state.roles_detail = data;
  },

  // users
  setUsersList: (state, data) => {
    state.users_list = data;
  },
  setUsersDetail: (state, data) => {
    state.users_detail = data;
  },
  setUsersLogActivity: (state, data) => {
    state.users_log_activity = data;
  },
  setUsersLogActivityChart: (state, data) => {
    state.users_log_activity_chart = data;
  },
  setUsersLog: (state, data) => {
    state.users_log = data;
  },
  setUsersProfile: (state, data) => {
    state.users_profile = data;
  },

  // users tactical
  setUsersTacticalList: (state, data) => {
    state.users_tactical_list = data;
  },

  // acl
  setAclList: (state, data) => {
    state.acl_list = data;
  },

  // tactical devices
  setTacticalDevicesList: (state, data) => {
    state.tactical_devices_list = data;
  },
  setTacticalDevicesDetail: (state, data) => {
    state.tactical_devices_detail = data;
  },
  setTacticalDevicesListMap: (state, data) => {
    state.tactical_devices_list_map = data;
  },
  setTacticalDevicesMapLocation: (state, data) => {
    state.tactical_devices_map_location = data;
  },

  // territory virtual
  setTerritoryVirtualList: (state, data) => {
    state.territory_virtual_list = data;
  },
  // for edit / update
  setTerritoryVirtualDetail: (state, data) => {
    state.territory_virtual_detail = data;
  },
  // for detail page & notif
  setTerritoryVirtualDetailMapData: (state, data) => {
    state.territory_virtual_detail_map_data = data;
  },
  setTerritoryVirtualDetailMapHistory: (state, data) => {
    state.territory_virtual_detail_map_history = data;
  },
  setTerritoryVirtualDetailHistoryList: (state, data) => {
    state.territory_virtual_detail_history_list = data;
  },

  // case management
  setCaseManagementList: (state, data) => {
    state.case_management_list = data;
  },
  setCaseManagementDetail: (state, data) => {
    state.case_management_detail = data;
  },

  // single target
  setSingleTargetList: (state, data) => {
    state.single_target_list = data;
  },
  setSingleTargetDetail: (state, data) => {
    state.single_target_detail = data;
  },

  setSingleMonitoringList: (state, data) => {
    state.single_monitoring_list = data;
  },

  setSingleTargetTrackingList: (state, data) => {
    state.single_target_tracking_list = data;
  },

  // multi tracking / target
  setMultiTrackingList: (state, data) => {
    state.multi_tracking_list = data;
  },
  setMultiTrackingDetail: (state, data) => {
    state.multi_tracking_detail = data;
  },

  setMultiMonitoringList: (state, data) => {
    state.multi_monitoring_list = data;
  },

  setRecentLocationESList: (state, data) => {
    state.recent_location_es_list = data;
  },

  // meeting_point
  setMeetingPointList: (state, data) => {
    state.meeting_point_list = data;
  },
  setMeetingPointDetail: (state, data) => {
    state.meeting_point_detail = data;
  },

  // result page
  setProfileSubheader: (state, data) => {
    state.profile_subheader = data;
  },
  setProfileSubheaderName: (state, data) => {
    console.log('aaaa')
    console.log(data)
    state.profile_subheader_name = data;
  },
  setProfileIdentity: (state, data) => {
    state.profile_identity = data;
  },
  setProfileFamily: (state, data) => {
    state.profile_family = data;
  },
  setOverallAppUsage: (state, data) => {
    state.overall_app_usage = data;
  },
  setOverallDataLocation: (state, data) => {
    state.overall_data_location = data;
  },
  setOverallLogRecentLocation: (state, data) => {
    state.overall_log_recent_location = data;
  },
  // location
  setLocationDetail: (state, data) => {
    state.location_detail = data;
  },
  setLocationHistory: (state, data) => {
    state.location_history = data;
  },
  // browsing
  setBrowsingHistory: (state, data) => {
    state.browsing_history = data;
  },
  setBrowsingLog: (state, data) => {
    state.browsing_log = data;
  },
  setBrowsingIpAddress: (state, data) => {
    state.browsing_ip_address = data;
  },
  setBrowsingUsage: (state, data) => {
    state.browsing_usage = data;
  },
  setBrowsingDuration: (state, data) => {
    state.browsing_duration = data;
  },
  setBrowsingAccessDomain: (state, data) => {
    state.browsing_access_domain = data;
  },
  setDeviceHistory: (state, data) => {
    state.device_history = data;
  },
  setTetheredDevice: (state, data) => {
    // console.log('============= in setTetheredDevice');
    // console.log(data);
    state.tethered_device = data;
  },
  setPossibleLocation: (state, data) => {
    state.possible_location = data;
  },
  setAerialLog: (state, data) => {
    state.aerial_log = data;
  },
  setSignalStatus: (state, data) => {
    state.signal_status = data;
  },
  setVehicles: (state, data) => {
    state.vehicles = data;
  },
  setVehiclesStatus: (state, status) => {
    state.vehicles_status = status;
  },
  setEtle: (state, data) => {
    state.etle = data;
  },
  // get contact
  setGetContact: (state, data) => {
    state.get_contact = data;
  },
  setTravelHistory: (state, data) => {
    state.travel_history = data;
  },
  setTravel: (state, data) => {
    state.travel = data;
  },
  setTokped: (state, data) => {
    state.tokped = data;
  },
  setBankAccount: (state, data) => {
    state.bank_account = data;
  },
  setPersonalIdentity: (state, data) => {
    state.personal_identity = data;
  },

  // face recognition
  setFaceRecognition: (state, data) => {
    state.face_recognition = data;
  },
  // search by name
  setSearchByName: (state, data) => {
    state.search_by_name = data;
  },
  setSearchByNameFilter: (state, [type, data]) => {
    state['search_by_name_filter_' + type] = data;
  },
  // setSearchByNameFilterProvince: (state, data) => {
  //   state.search_by_name_filter_province = data;
  // },
  // setSearchByNameFilterCity: (state, data) => {
  //   state.search_by_name_filter_city = data;
  // },
  // setSearchByNameFilterDistrict: (state, data) => {
  //   state.search_by_name_filter_district = data;
  // },

  // search by name travel history
  setSearchByNameTravelHistory: (state, data) => {
    state.search_by_name_travel_history = data;
  },

  // search by name paspor
  setSearchByNamePaspor: (state, data) => {
    state.search_by_name_paspor = data;
  },
  // search by name marketplace
  setSearchByNameMarketplace: (state, data) => {
    state.search_by_name_marketplace = data;
  },
  // search by name university
  setSearchByNameUniversity: (state, data) => {
    state.search_by_name_university = data;
  },

  // search by name or username personal identity
  setSearchByNamePersonalIdentity: (state, data) => {
    state.search_by_name_personal_identity = data;
  },

  // search by name pln
  setSearchByNamePln: (state, data) => {
    state.search_by_name_pln = data;
  },

  // notification
  setNotificationList: (state, data) => {
    state.notification_list = data;
  },
  setNotificationCount: (state, data) => {
    state.notification_count = data;
  },
  // tracking_history
  setTrackingHistoryList: (state, data) => {
    state.tracking_history_list = data;
  },

  // case note
  setNoteCaseList: (state, data) => {
    state.note_case_list = data;
  },

  // target note
  setNoteTargetList: (state, data) => {
    state.note_target_list = data;
  },

  // download app
  setDownloadApp: (state, data) => {
    state.download_app = data;
  },

  // bot menu
  setLoadDataStatusBotMenuList: (state, status) => {
    state.load_data_status_bot_menu_list = status;
  },
  setBotMenuList: (state, data) => {
    state.bot_menu_list = data;
  },
}
